import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const ppuAbTestVariantSchema = z.object({
  id: zExt.objectId(),
  name: z.string(),
  ppuPageName: z.string(),
});

export const getPpuAbTestDetail = {
  name: "getPpuAbTestDetail" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({
    name: z.string(),
    description: z.string().optional(),
    status: z.literal("in_progress").or(z.literal("concluded")),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    controlTreatmentId: zExt.objectId(),
    variants: z.array(ppuAbTestVariantSchema),
  }),
};

export type PpuAbTestVariant = z.infer<typeof ppuAbTestVariantSchema>;
